/* eslint-disable*/
import { notification } from 'antd';
import axios from 'axios';
import { setToken } from '../component/login/action';
import store from '../store';
import * as mostApi from './api';
import { clearAllStorage, getMockAPI, getPlatformTokenInfo, getToken, getTokens, hasToken, setPlatformTokenInfo, toLogin, Utils } from './utils';

let time;
let timer1;
// let CancelToken = axios.CancelToken;
// let source = CancelToken.source();

/* 是否有请求正在刷新token */
window.isRefreshing = false;
/* 被挂起的请求数组 */
let refreshSubscribers = [];

/* push所有请求到数组中 */
function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
}

/* 刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据） */
function onRrefreshed(token) {
    refreshSubscribers.map((cb) => cb(token));
}
function computedTime() {
    let tokenInfo = getPlatformTokenInfo();
    if (Object.keys(tokenInfo).length === 0 || !tokenInfo.expires_in || !tokenInfo.nowTime) return false;
    let currentTime = Date.parse(new Date()) / 1000;
    let expiresTime = tokenInfo.expires_in;
    let getTokenTime = tokenInfo.nowTime;
    // 600秒后即将过期,true则需要刷新
    return expiresTime + getTokenTime - currentTime <= 600;
}
//请求拦截器的添加，自动刷新token
axios.interceptors.request.use(
    async (config) => {
        config.headers = {
            ...config.headers,
            app: 'tenant_pc',
        };
        if (!config.url.startsWith('/api/organization/oauth/token')) {
            // 新登录，去掉access-token,使用Authorization
            let tokenInfo = getPlatformTokenInfo();
            if (config.headers && config.headers.hasOwnProperty('access-token') && tokenInfo) {
                delete config.headers['access-token'];
                const token = tokenInfo['token_type'] && tokenInfo['access_token'] ? tokenInfo['token_type'] + tokenInfo['access_token'] : '';
                config.headers['Authorization'] = token;
            }
            // 刷新token操作
            if (computedTime()) {
                if (!window.isRefreshing) {
                    window.isRefreshing = true;
                    tokenInfo = getPlatformTokenInfo();
                    if (!tokenInfo || !tokenInfo.refresh_token) return config;
                    let refreshData = {
                        refreshToken: tokenInfo.refresh_token,
                    };
                    getTokens(refreshData)
                        .then((r) => {
                            const res = r.data;
                            if (res.data && res.data.access_token && res.status === 200) {
                                const _tokenInfo = {
                                    access_token: res.data.access_token,
                                    token_type: res.data.token_type,
                                    refresh_token: res.data.refresh_token,
                                    expires_in: res.data.expires_in,
                                    loginWay: 'newLogin',
                                    nowTime: Date.parse(new Date()) / 1000,
                                };
                                //存储token，存进redux里面
                                store.dispatch(setToken(res.data.token_type + res.data.access_token));
                                //存储token以及refreshToken等信息，存进存储里面
                                setPlatformTokenInfo(JSON.stringify(_tokenInfo));
                                window.isRefreshing = false;
                                onRrefreshed(res.data.token_type + res.data.access_token);
                                /* 执行onRefreshed函数后清空数组中保存的请求 */
                                refreshSubscribers = [];
                            } else {
                                clearTimeout(timer1);
                                timer1 = setTimeout(() => {
                                    const args = {
                                        message: '提示',
                                        description: '登录已过期，请重新登录',
                                        duration: 2,
                                    };
                                    notification.warning(args);
                                    toLogin(); //跳转到登录页
                                    clearAllStorage();
                                }, 200);
                            }
                        })
                        .catch((err) => {
                            clearTimeout(timer1);
                            timer1 = setTimeout(() => {
                                const args = {
                                    message: '提示',
                                    description: '登录已过期，请重新登录',
                                    duration: 2,
                                };
                                notification.warning(args);
                                toLogin(); //跳转到登录页
                                clearAllStorage();
                            }, 200);
                        });
                }
                /* 把请求(token)=>{....}都push到一个数组中 */
                let retry = new Promise((resolve, reject) => {
                    /* (token) => {...}这个函数就是回调函数 */
                    subscribeTokenRefresh((token) => {
                        config.headers.Authorization = token;
                        /* 将请求挂起 */
                        resolve(config);
                    });
                });
                return retry;
            } else {
                return config;
            }
        } else {
            return config;
        }
    },
    (error) => {
        return Promise.reject(error);
    },
);

const axios_ = (config = {}, props) => {
    if (!!config.noToken) {
        delete config.headers['access-token'];
        delete config.headers['Authorization'];
    }
    return new Promise((resolve, reject) => {
        Object.keys(mostApi).forEach((ele) => {
            // if (mostApi[ele][config.url]) {
            //   config.url = mostApi[ele][config.url];
            //     if ((config.method && config.method.toUpperCase() === "GET") &&  config.url.indexOf("?") < 0){//未解决IE下get请求的缓存问题，在url后追加时间戳字段
            //         config.url = config.url + "?timeStamp=" +new Date().getTime();
            //     }else if ((config.method && config.method.toUpperCase() === "GET") &&  config.url.indexOf("?") > 0) {
            //         config.url = config.url + "&timeStamp=" +new Date().getTime();
            //     }
            // }
            if (mostApi[ele] && mostApi[ele][config.url]) {
                // 兼容windows
                config.url = mostApi[ele][config.url];
                if (config.method && config.method.toUpperCase() === 'GET' && config.url.indexOf('?') < 0) {
                    //未解决IE下get请求的缓存问题，在url后追加时间戳字段
                    config.url = config.url + '?timeStamp=' + new Date().getTime();
                } else if (config.method && config.method.toUpperCase() === 'GET' && config.url.indexOf('?') > 0) {
                    config.url = config.url + '&timeStamp=' + new Date().getTime();
                }
            }
        });
        // config.url = "http://platform.zhongbaolianmeng.com/grainbuds" + config.url;
        axios
            .request({
                ...config
            })
            .then((res) => {
                if (res.data.status === 40101 || res.data.status === 70001 || res.data.status === 70000 || res.data.code === 50000 || res.data.code === 60001) {
                    clearTimeout(timer1);
                    timer1 = setTimeout(() => {
                        const args = {
                            message: '提示',
                            description: '登录已过期，请重新登录',
                            duration: 2,
                        };
                        hasToken() && notification.warning(args);
                        toLogin(); //跳转到登录页
                        clearAllStorage();
                    }, 200);
                } else if (
                    res.data.status >= 400 ||
                    (res.data.code !== undefined && res.data.code !== 0 && res.data.code !== 10000 && res.data.code !== '200')
                ) {
                    // todo 该接口返回的code码不规范，会报警告。临时屏蔽掉。
                    if (res.config.url.includes('/api/admin/baseGroup/get') || res.config.url.includes('/api/market/proposal/api/v5/orderInsure/processUrl')) {
                        resolve(res);
                    } else {
                        const { msg = '', message = '', errcode = '' } = res.data; // msg和errcode是后台新加的字段
                        if (res.status === 200 && res.config.url.indexOf('/api/v2') > -1 && res.data.status !== 500 && res.data.code !== 2000) {
                            notification.success({
                                message: errcode || '提示',
                                description: msg || message,
                                duration: 2,
                            });
                            resolve(res);
                        } else {
                            notification.warning({
                                message: errcode || '提示',
                                description: msg || message,
                                duration: 2,
                            });
                            resolve(res);
                        }
                    }
                } else {
                    resolve(res);
                }
            })
            .catch((e) => {
                clearTimeout(time);
                if (e.response && e.response.status === 404) {
                    time = setTimeout(() => {
                        const args = {
                            message: '提示',
                            description: '服务器地址错误,请反馈',
                            duration: 2,
                        };
                        notification.error(args);
                    }, 1000);
                } else {
                    if (e.config && e.config.url.indexOf('/api/v2') > -1 && e.response.status === 403) {
                        window.location.href = '/grainbuds#/authority';
                    } else if (e.config && e.config.url.indexOf('/api/v2') > -1 && e.response.status === 401) {
                        clearTimeout(timer1);
                        timer1 = setTimeout(() => {
                            const args = {
                                message: '提示',
                                description: '登录已过期，请重新登录',
                                duration: 2,
                            };
                            hasToken() && notification.warning(args);
                            toLogin(); //跳转到登录页
                            clearAllStorage();
                        }, 200);
                    } else {
                        time = setTimeout(() => {
                            const args = {
                                message: '提示',
                                description: '服务器出现异常',
                                duration: 2,
                            };
                            notification.error(args);
                        }, 1000);
                    }
                }
                reject(e);
            });
    });
};

export { axios_ };

/**
 * get请求
 * @param {*} param0 noRespStatus: false表示直接返回报文，没有status、message字段
 */
export const doGetRequest = ({ url = '', params = {}, noRespStatus = false, isMock = false, noToken = false, MOCK_REPO_ID = '' }) =>
    new Promise((resolve, reject) => {
        axios_({
            url: isMock ? getMockUrl(url, MOCK_REPO_ID) : url,
            params: {
                ...params,
                orgId: Utils.getOrgId(),
            },
            noToken,
            method: 'get',
            headers: { Authorization: getToken()},
        })
            .then((res) => {
                if (noRespStatus) {
                    // 这种格式不返回status，直接返回报文
                    resolve(res.data || {});
                } else {
                    if (res.data.status === 200 || res.data.code === 0 || res.data.code === 1000) {
                        resolve(res.data || {});
                    } else if (res.status === 200 && url.indexOf('api/v2') > -1) {
                        resolve(res || {});
                    } else if (res.status === 200 && (url.indexOf('api/company') > -1 || url.indexOf('api/admin') > -1)) {
                        resolve(res || {});
                    } else {
                        reject(res);
                    }
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

/**
 * post请求
 * @param {*} param0 noRespStatus: false表示直接返回报文，没有status、message字段
 */
export const doPostRequest = ({ url = '', data = {}, noRespStatus = false, isMock = false, noToken = false, MOCK_REPO_ID = '', headers = {} }) =>
    new Promise((resolve, reject) => {
        axios_({
            url: isMock ? getMockUrl(url, MOCK_REPO_ID) : url,
            data: {
                ...data,
                orgId: Utils.getOrgId(),
            },
            noToken,
            method: 'post',
            headers: { Authorization: getToken(), ...headers}
        })
            .then((res) => {
                if (noRespStatus) {
                    // 这种格式不返回status，直接返回报文
                    resolve(res.data || {});
                } else {
                    if (res.data.status === 200 || res.data.code === 0 || res.data.code === 1000 || res.data.code === '0') {
                        resolve(res.data || {});
                    } else if (res.status === 200 && url.indexOf('api/v2') > -1) {
                        resolve(res || {});
                    } else {
                        reject(res);
                    }
                }
            })
            .catch((err) => reject(err));
    });

/**
 * post请求
 * @param {*} param0 noRespStatus: false表示直接返回报文，没有status、message字段
 */
export const doPutRequest = ({ url = '', data = {}, noRespStatus = false, isMock = false, noToken = false, MOCK_REPO_ID = '' }) =>
    new Promise((resolve, reject) => {
        axios_({
            url: isMock ? getMockUrl(url, MOCK_REPO_ID) : url,
            data: {
                ...data,
                orgId: Utils.getOrgId(),
            },
            noToken,
            method: 'PUT',
            headers: { Authorization: getToken()},
        })
            .then((res) => {
                console.log(res);
                if (noRespStatus) {
                    // 这种格式不返回status，直接返回报文
                    resolve(res.data || {});
                } else {
                    if (res.data.status === 200 || res.data.code === 0 || res.data.code === 1000) {
                        resolve(res.data || {});
                    } else {
                        reject(res);
                    }
                }
            })
            .catch((err) => reject(err));
    });
// mock前缀 + 接口地址
const getMockUrl = (url = '', MOCK_REPO_ID = '') => {
    const mockRepo = MOCK_REPO_ID || process.env.REACT_APP_MOCK_REPO_ID; // rap2仓库id,优先从接口参数里取
    const prefix = getMockAPI() + `/${mockRepo}`; // rap2 API地址
    const env = process.env.NODE_ENV || '';
    return env === 'mock' ? prefix + url : url;
};
export const doDeleteRequest = ({ url = '', params = {}, noRespStatus = false, isMock = false, noToken = false, MOCK_REPO_ID = '' }) =>
    new Promise((resolve, reject) => {
        axios_({
            url: isMock ? getMockUrl(url, MOCK_REPO_ID) : url,
            params: {
                ...params,
                orgId: Utils.getOrgId(),
            },
            noToken,
            method: 'delete',
            headers: { Authorization: getToken() },
        })
            .then((res) => {
                if (noRespStatus) {
                    // 这种格式不返回status，直接返回报文
                    resolve(res.data || {});
                } else {
                    if (res.data.status === 200 || res.data.code === 0 || res.data.code === 1000) {
                        resolve(res.data || {});
                    } else {
                        reject(res);
                    }
                }
            })
            .catch((err) => reject(err));
    });
